import { m } from "@/paraglide/messages.js";
import { Language, type AppLanguage } from "@complete-athlete/enums";

const NAMES: Record<AppLanguage, () => string> = {
  [Language.EN]: () => m.language_en(),
  [Language.PL]: () => m.language_pl(),
};

/** A language named in the page's language: "Polski" in Polish, "Polish" in English. */
export const languageName = (language: AppLanguage) => NAMES[language]();
